module.exports = {"language":"zh","profile":"cube"}


//////////////////
// WEBPACK FOOTER
// ./config/cube.json
// module id = 2388
// module chunks = 1